import calculateHash from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateHash';

function compileRowCacheKey(row) {
    row.cacheKey = calculateHash([
        row.hash,
        row.compiled,
        row.labelLeft,
        row.labelRight,
        row.transformation,
        row.index,
        row.seats.toModelArray().map(seat => seat.cacheKey),
    ]);

    return row;
}

export default compileRowCacheKey;
